module.exports = __webpack_public_path__ + "img/news3.5e67afb2.jpg";